import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const TableHeader = ({ headers }) => {
	const { i18n } = useGlobal()

	return (
		<thead>
			<tr>
				{headers.map((header, index) => (
					<th key={index}>{i18n.translate(header)}</th>
				))}
			</tr>
		</thead>
	)
}

const TableRow = ({ row }) => {
	const { i18n } = useGlobal()

	return (
		<tr>
			<td>{row.requisitionId}</td>
			<td>{i18n.translate(row.requisitionType)}</td>
			<td>{i18n.translate(row.requisitionState)}</td>
			<td>
				<a href={`/clinical-processes/${row.processId}`}>
					{row.processId}
				</a>
			</td>
		</tr>
	)
}

const TableBody = ({ data }) => {
	return data.map((requisition, index) => {
		return <TableRow key={index} row={requisition} />
	})
}

const MissingTasksRequisitionsTable = ({ data }) => {
	return data?.length ? (
		<table>
			<TableHeader headers={Object.keys(data[0])} />
			<tbody>
				<TableBody headers={Object.keys(data[0])} data={data} />
			</tbody>
		</table>
	) : null
}

export default MissingTasksRequisitionsTable
